import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getUrlVars } from "../utils/systemInfo";
import HubServerInfoService from "../api/hubServerInfo";
import TemplateAddEdit from "../common/Layout/templatePages/templateAddEdit";
import { setAddHubServerAttribute } from "../store/addHubServerAttributeSlice";
import { showMessage } from "../store/messageSlice";

const breadcrumbs = [
    { id: 0, name: "Home", href: "./" },
    { id: 1, name: "HUB Server Attributes", href: "hubServerAttributes" },
    { id: 2, name: "Add/Edit HUB Server Attribute" }
];
function AddEditHubServerAttribute() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const hubServerAttribute = useSelector(({ addHubServerAttribute }) => addHubServerAttribute);
    const organziation = useSelector(({ organziation }) => organziation);
    const AttributeId = String(getUrlVars()["id"]);
    const ServerId = String(getUrlVars()["serverId"]);    
    const { t } = useTranslation();

    useEffect(() => {
        if (!hubServerAttribute?.hub_server_info_attribute_id && AttributeId && AttributeId !== "undefined") {
            const apiKey = organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
            HubServerInfoService.GetHUBServerInfoAttribute({
                hub_server_info_attribute_id: AttributeId,
                hub_server_info_id: "",
                name: "",
                status: "",
                apiKey,
            })
                .then((jsonAttribute) => {
                    if (jsonAttribute?.data?.hub_server_info_attributes?.length) {
                        dispatch(setAddHubServerAttribute(jsonAttribute.data?.hub_server_info_attributes[0]));
                    }
                    else {
                        navigate(`/hubServerAttributes?serverId=${ServerId}`);
                    }
                })
                .catch((errorr) => {
                    navigate(`/hubServerAttributes?serverId=${ServerId}`);
                    if (process.env.NODE_ENV === "development")
                        console.log("GetHUBServerInfoAttributeerror", errorr);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hubServerAttribute]);

    function handleSave(item) {
        HubServerInfoService.SetHUBServerInfoAttribute(item).then((json) => {
            if (json?.data?.success && json.data.count) {
                dispatch(
                    showMessage({
                        message: t("Saved Successfully"), //text or html
                        autoHideDuration: 10000, //ms
                        anchorOrigin: {
                            vertical: "top", //top bottom
                            horizontal: "center", //left center right
                        },
                        variant: "success", //success error info warning null
                    })
                );
                navigate(`/hubServerAttributes?serverId=${ServerId}`);
            } else {
                dispatch(
                    showMessage({
                        message: t("error occurred"), //text or html
                        autoHideDuration: 10000, //ms
                        anchorOrigin: {
                            vertical: "top", //top bottom
                            horizontal: "center", //left center right
                        },
                        variant: "error", //success error info warning null
                    })
                );
            }
        });
    }
    return (
        <TemplateAddEdit
            breadcrumbs={breadcrumbs}
            title="Add/Edit HUB Server Attribute"
            gridCol={2}
            item={hubServerAttribute}
            dataToShow={[
                { key: "name", isRequired: true },
                { key: "value", isRequired: true, type: hubServerAttribute.data_type },
                { key: "data_type", label: "Data Type" },
                { key: "attribute_type", label: "Attribute Type" },
                { key: "description" },
                { key: "status" }
            ]}
            onSaveClick={(item) =>
                handleSave({
                    ...item,
                    hub_server_info_id: ServerId,
                    hub_server_info_attribute_id: AttributeId,
                    apiKey: organziation?.api_key_list?.[0]?.key
                })
            }
        />
    );
}

export default AddEditHubServerAttribute;
